/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./smartservice.vue?vue&type=template&id=665f9cb2&scoped=true&"
import script from "./smartservice.vue?vue&type=script&lang=js&"
export * from "./smartservice.vue?vue&type=script&lang=js&"
import style0 from "./smartservice.vue?vue&type=style&index=0&id=665f9cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665f9cb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VDataTable,VRow,VTextField})
